import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";


export default function Allblogs() {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        try {
            const response = await axios.get("https://harasky.com/api/user/api.php");
            setBlogs(response.data);
        } catch (error) {
            console.error("Error fetching blogs:", error);
        }
    };

    return (
        <>
            <section id="Blogs" className='mb-5'>
                <div className="container">

                    <div className="row custmargin">
                        <div className="div col-md-12">
                            <div className="headingTextBox mt-5"  >
                                <span>Updates News</span>
                                <h3>
                                    Latest Posts
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {blogs.map((blog) => (
                            <div className="col-md-4" key={blog.id}>
                                <Link to={`/blog/${blog.slugurl}`} className="text-decoration-none">
                                    <div className="blogMain">
                                        <div className="blogImg">
                                            <img
                                                src={`https://harasky.com/api/uploads/${blog.bimg}`}
                                                alt={blog.btitle}
                                            />
                                        </div>
                                        <div className="blogtext">
                                            <span>{new Date(blog.bdate).toLocaleDateString()}</span>
                                            <p>{blog.btitle}</p>
                                            <span className="read-more">Read More</span>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}
